// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MessagesComponent } from './messages.component';
import { RouterModule } from '@angular/router';
import { MessagesRoutingModule } from './messages-routing.module';
import { ClientsComponent } from './clients/clients.component';
import { ChatComponent } from './chat/chat.component';
import { TeamsComponent } from './teams/teams.component';
import { ToastrModule } from 'ngx-toastr';
// import { FilterPipeModule } from 'ngx-filter-pipe';
import { SearchPipe } from '../shared/filter.pipe';
import { SharedModule } from '../shared/shared.module';
import { NgxSpinnerModule} from 'ngx-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LucideAngularModule } from "lucide-angular";

@NgModule({
    imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    MessagesRoutingModule,
    ToastrModule.forRoot(),
    //FilterPipeModule,
    SharedModule,
    MatIconModule,
    MatTooltipModule,
    LucideAngularModule
],
    declarations: [
        MessagesComponent,
        ClientsComponent,
        ChatComponent,
        TeamsComponent,
        
       
    ],
    exports: [
        
    ]
})
export class MessagesModule {
    

}
